// extracted by mini-css-extract-plugin
export const copyright = "copyright-module--copyright--7TIQj";